export default "__VITE_ASSET__JZGg098P__"